import React from 'react';
import { PartyPopper, Wrench, RotateCcw, AlertTriangle, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconComponents = [PartyPopper, Wrench, RotateCcw, AlertTriangle, Shield];

const LifecycleSupportSection = () => {
  const { t } = useLanguage();
  const stages = t('lifecycle.stages');

  return (
    <section className="py-16 bg-white relative">
      <div className="absolute inset-0 blueprint-grid opacity-30" />
      
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-6">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0d1442] mb-4">
            {t('lifecycle.title')} <span className="gradient-text">{t('lifecycle.titleHighlight')}</span>
          </h2>
          <p className="text-lg text-slate-600">
            {t('lifecycle.subtitle')}
          </p>
        </div>

        {/* Lifecycle Cards - prevent solo cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-8">
          {Array.isArray(stages) && stages.map((stage, index) => {
            const IconComponent = iconComponents[index];
            return (
              <div 
                key={stage}
                className="lifecycle-card bg-white rounded-2xl p-6 border border-slate-100 shadow-sm text-center"
              >
                <div className="icon-badge w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <IconComponent className="w-7 h-7 text-[#1a237e]" />
                </div>
                <h3 className="text-base font-semibold text-[#0d1442]">{stage}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LifecycleSupportSection;
